import { render, staticRenderFns } from "./AppDetailContactSync.vue?vue&type=template&id=47fd9f3c&scoped=true";
import script from "./AppDetailContactSync.vue?vue&type=script&lang=js";
export * from "./AppDetailContactSync.vue?vue&type=script&lang=js";
import style0 from "./AppDetailContactSync.vue?vue&type=style&index=0&id=47fd9f3c&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "47fd9f3c", null);
export default component.exports;